export const UPDATE_THEME_SCHEMA = "UPDATE_THEME_SCHEMA";

export function updateThemeSchema(theme_schema) {
    return {
        type: UPDATE_THEME_SCHEMA,
        payload: theme_schema
    };
}
